import type { FeedbackType } from "@asurion-core/expert-workspace-feedback";
import type { Partner } from "@expert/shared-types";

import { FeedbackPortal } from "@asurion-core/expert-workspace-feedback";

import type { TaskStatus } from "@/sdk";

import { useLogger } from "@/sdk/logging/LoggerProvider";

import { useFeedbackNotification } from "./hooks";

interface SidebarFeedbackButtonProps {
    feedbackPayload: {
        appName: string;
        sessionId: string;
        callSid: string | undefined;
        feedbackType: FeedbackType;
        ssoAccessToken: string;
        partner: Partner;
    };
    activeTaskStatus?: TaskStatus;
}

export function SidebarFeedbackButton({ activeTaskStatus, feedbackPayload }: SidebarFeedbackButtonProps) {
    const logger = useLogger({ module: "SidebarFeedbackButton" });
    const showFeedbackNotification = useFeedbackNotification();
    const { sessionId, callSid } = feedbackPayload;

    return (
        <FeedbackPortal
            payload={{
                ...feedbackPayload,
                caller: "PlatformTimeline",
            }}
            showNotification={showFeedbackNotification}
            taskStatus={activeTaskStatus}
            logger={logger.child({
                supportTeam: "solve",
                sessionId,
                callSid,
            })}
            source="Sidebar"
        />
    );
}
